export default __webpack_public_path__ + "static/media/designing.989c103e.svg";